export const comments = [
  {
    id: 'c1',
    articleId: '1',
    user: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20style%20avatar%20with%20warm%20beige%20background%2C%20simple%20abstract%20face%20illustration%2C%20clean%20flat%20design%2C%20neutral%20warm%20tones&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '哈哈哈哈笑死我了，终于翻车了！之前看她那个样子就知道迟早要出事，粉丝在她眼里就是韭菜呗。这次彻底凉凉了吧！',
    date: '2026-06-30',
    likes: 15234,
  },
  {
    id: 'c2',
    articleId: '1',
    user: '理性吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20style%20avatar%20with%20soft%20peach%20background%2C%20simple%20abstract%20face%20illustration%2C%20clean%20flat%20design%2C%20warm%20neutral%20tones&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '虽然但是，聊天记录的内容确实太让人寒心了。那些真心支持她的粉丝看到这种话，得多难过啊。做网红之前先学会做人吧。',
    date: '2026-06-30',
    likes: 8921,
  },
  {
    id: 'c3',
    articleId: '2',
    user: '娱乐圈观察员',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20style%20avatar%20with%20light%20sage%20background%2C%20simple%20abstract%20face%20illustration%2C%20clean%20flat%20design%2C%20neutral%20warm%20tones&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '都三十好几了谈个恋爱怎么了？粉丝也别太玻璃心了。明星也是人，有七情六欲很正常。只要不违法乱纪，私生活应该被尊重。',
    date: '2026-06-29',
    likes: 12340,
  },
  {
    id: 'c4',
    articleId: '2',
    user: '八卦小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20style%20avatar%20with%20dusty%20rose%20background%2C%20simple%20abstract%20face%20illustration%2C%20clean%20flat%20design%2C%20warm%20neutral%20tones&width=100&height=100&seq=avatar-04&orientation=squarish',
    content: '关键问题不是谈恋爱，是他之前一直对外宣称单身人设，靠这个吸了多少女友粉？如果从一开始就大大方方的，大家反应不会这么大。',
    date: '2026-06-29',
    likes: 9876,
  },
  {
    id: 'c5',
    articleId: '3',
    user: '数据不撒谎',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20style%20avatar%20with%20warm%20sand%20background%2C%20simple%20abstract%20face%20illustration%2C%20clean%20flat%20design%2C%20neutral%20warm%20tones&width=100&height=100&seq=avatar-05&orientation=squarish',
    content: '早就觉得这个人数据不对劲了。120万粉丝的视频播放量才几千，评论都是些机器人模板，假得不能再假了。谢谢技术大佬扒皮！',
    date: '2026-06-28',
    likes: 11245,
  },
  {
    id: 'c6',
    articleId: '4',
    user: '电视儿童',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20style%20avatar%20with%20light%20terracotta%20background%2C%20simple%20abstract%20face%20illustration%2C%20clean%20flat%20design%2C%20warm%20neutral%20tones&width=100&height=100&seq=avatar-06&orientation=squarish',
    content: '虽然早就知道综艺有剧本，但看到这么详细的内幕还是有点震撼。以后看综艺就当电视剧看吧，反正都是演的。',
    date: '2026-06-27',
    likes: 6745,
  },
  {
    id: 'c7',
    articleId: '10',
    user: '资深吃瓜er',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20style%20avatar%20with%20warm%20cream%20background%2C%20simple%20abstract%20face%20illustration%2C%20clean%20flat%20design%2C%20neutral%20warm%20tones&width=100&height=100&seq=avatar-07&orientation=squarish',
    content: '这一周瓜太多了根本吃不过来！每天刷91爆料网都能看到新瓜，太刺激了！突然觉得网红这行也不好干啊，翻车就是一瞬间的事。',
    date: '2026-06-21',
    likes: 15678,
  },
  {
    id: 'c8',
    articleId: '10',
    user: '冷静分析者',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20style%20avatar%20with%20pale%20olive%20background%2C%20simple%20abstract%20face%20illustration%2C%20clean%20flat%20design%2C%20warm%20neutral%20tones&width=100&height=100&seq=avatar-08&orientation=squarish',
    content: '这波集中爆发不是偶然的。行业野蛮生长这么多年，是该到规范的时候了。希望这次整顿能让整个行业变得更健康，对消费者也是好事。',
    date: '2026-06-22',
    likes: 8923,
  },
  {
    id: 'c9',
    articleId: '6',
    user: '维权在路上',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20style%20avatar%20with%20warm%20taupe%20background%2C%20simple%20abstract%20face%20illustration%2C%20clean%20flat%20design%2C%20neutral%20warm%20tones&width=100&height=100&seq=avatar-09&orientation=squarish',
    content: '我就是受害者之一！用了那个美容仪之后脸肿了两天，找客服根本不理。已加入维权群，坚决维权到底！让无良网红和黑心商家付出代价！',
    date: '2026-06-26',
    likes: 11234,
  },
  {
    id: 'c10',
    articleId: '9',
    user: '前选秀粉',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20style%20avatar%20with%20soft%20blush%20background%2C%20simple%20abstract%20face%20illustration%2C%20clean%20flat%20design%2C%20warm%20neutral%20tones&width=100&height=100&seq=avatar-10&orientation=squarish',
    content: '看完这篇真的破防了。当年为了给喜欢的选手投票，省吃俭用花了好几千块钱。现在知道原来我的票根本没用，真的心碎。选秀节目我再也不看了。',
    date: '2026-06-23',
    likes: 20345,
  },
];